import { Navigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { clearAuth, getAuthUser, setAuthUser, loginOrRegisterWithPhone } from "./authStore";
import { authReady } from "data/firebase";

const RequireAuth = ({ children }) => {
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const firebaseUser = await authReady;
        if (cancelled) return;

        if (firebaseUser) {
          const local = getAuthUser();
          if (!local || local.id !== firebaseUser.uid) {
            setAuthUser({
              id: firebaseUser.uid,
              provider: firebaseUser.providerData?.[0]?.providerId || "unknown",
              phone: firebaseUser.phoneNumber || null,
              email: firebaseUser.email || null,
              displayName: firebaseUser.displayName || null,
              role: local?.role || "editor",
              createdAt: local?.createdAt || new Date().toISOString(),
            });
          }
          setAuthenticated(true);
        } else {
          const local = getAuthUser();
          setAuthenticated(Boolean(local));
        }
      } catch {
        const local = getAuthUser();
        setAuthenticated(Boolean(local));
      } finally {
        if (!cancelled) setChecking(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (checking) {
    return null;
  }

  if (!authenticated) {
    return <Navigate to="/auth/login" replace state={{ from: location }} />;
  }

  return children;
};

export const RequireNonGuest = ({ children, redirectTo = "/admin/content/legends" }) => {
  const user = getAuthUser();
  const role = String(user?.role || "").toLowerCase();
  const provider = String(user?.provider || "").toLowerCase();
  const isGuest = role === "guest" || provider === "guest";
  if (isGuest) return <Navigate to={redirectTo} replace />;
  return children;
};

export const setAuthPhone = (phone) => {
  return !!loginOrRegisterWithPhone(phone);
};

export { clearAuth };

export default RequireAuth;
